import React, {Component} from "react";
import {Button, ButtonListCell, CardBody, DataRequestDetailListCell, List, ProcessStateListCell, StandardListCell} from "gd-react";
import GdModal from "../../components/GdModal/GdModal";
import NoItems from "../../components/noItems";
import {
    dataTypeLabel,
    deliverySummary,
    deviceCountLabel,
    frequencyDescription,
    granularityLabel,
    lastRunLabel,
    scheduleToFormState
} from "../../services/dataRequestTypes";
import CreateDataDownload from "../../pages/dataDownload/CreateDataDownload";
import DeliveryStatusCell from "../../pages/dataDownload/cells/DeliveryStatusCell";
import "./ScheduleRunsModal.scss";

// Runs are ordinary `request` rows that getMany hides, so they are fetched by parent_request_id.
class ScheduleRunsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {refreshRef: 0, editState: null};
        this.closeModal = this.closeModal.bind(this);
        this.runNow = this.runNow.bind(this);
        this.edit = this.edit.bind(this);
        this.editSaved = this.editSaved.bind(this);
    }

    closeModal() {
        this.props.onClose();
    }

    runNow() {
        let self = this;
        return this.props.onRun(this.props.schedule).then(function () {
            self.setState({refreshRef: self.state.refreshRef + 1});
        });
    }

    // the form holds devices as objects, so seeding it has to resolve them before it opens
    edit() {
        let self = this;
        return scheduleToFormState(this.props.schedule).then(function (editState) {
            self.setState({editState: editState});
        });
    }

    editSaved() {
        this.setState({editState: null, refreshRef: this.state.refreshRef + 1});
    }

    render() {
        const schedule = this.props.schedule;
        const columns = [
            // a run genuinely progresses, so the real spinner cell is correct here
            {component: ProcessStateListCell, title: 'Status', field: 'status', maxWidth: '50px'},
            {
                component: StandardListCell,
                title: 'Period',
                field: 'periodKey',
                maxWidth: '120px'
            },
            {
                component: DataRequestDetailListCell,
                type: 'dateRange',
                title: 'Date Range',
                field: 'assetIds'
            },
            {
                // why an export the user never received did not arrive; ListRow spreads the column
                // onto the cell, which is how the parent's delivery config reaches it
                component: DeliveryStatusCell,
                title: 'Delivery',
                field: 'deliveryError',
                notificationConfig: schedule.notificationConfig,
                maxWidth: 'none'
            },
            {
                component: ButtonListCell,
                title: "Download",
                field: "status",
                icon: 'FaDownload',
                disabled: (object) => object.status !== 'READY',
                color: 'gd-blue',
                onClick: this.props.onDownload,
                maxWidth: '80px'
            }
        ];

        // GdModal always renders the #drawer-footer the form portals its buttons into, and
        // getElementById takes the first one, so the edit form replaces this modal rather than
        // stacking on top of it
        if (this.state.editState) {
            return (
                <GdModal
                    open={this.props.open}
                    contentLabel={'Edit schedule'}
                    title={'Edit Schedule'}
                    wide
                    footer={true}
                    onClose={() => this.setState({editState: null})}>
                    <CardBody>
                        <CreateDataDownload ddState={this.state.editState}
                                            editing={schedule}
                                            onsubmit={this.editSaved}
                                            dataLoaded={true}/>
                    </CardBody>
                </GdModal>
            );
        }

        // no Frequency entry: the help row above already says it, at more length
        const info = [
            {label: 'Data Type', value: dataTypeLabel(schedule.dataType)},
            {label: 'Devices', value: deviceCountLabel(schedule.assetIds)},
            {label: 'Granularity', value: granularityLabel(schedule.granularity)},
            {label: 'Delivery', value: deliverySummary(schedule.notificationConfig)},
            {label: 'Last Run', value: lastRunLabel(schedule.lastRunAt)},
            // only worth saying when it is not the normal case
            {label: 'Status', value: schedule.active === false ? 'Paused' : 'Active'}
        ];

        return (
            <GdModal
                open={this.props.open}
                contentLabel={'Schedule runs'}
                title={(schedule.name ? schedule.name : 'Schedule') + ' — runs'}
                wide
                onClose={this.closeModal}>
                <CardBody>
                    {/* not `.row`: that carries flex:1, which made this header grow to match the list */}
                    <div className={'schedule-runs-header'}>
                        <p className={'help-row'}>{frequencyDescription(schedule.type)}</p>
                        <Button label={"Edit"} color={'gd-blue'} additionalclasses={'sm'}
                                onClick={this.edit} progressRes={true}/>
                        <Button label={"Run now"} color={'gd-green'} additionalclasses={'sm'}
                                onClick={this.runNow} progressRes={true}/>
                    </div>
                    {/* what each run will be made of, so the config is visible without opening Edit */}
                    <div className={'schedule-info'}>
                        {info.map(function (item) {
                            return (
                                <div className={'schedule-info-item'} key={item.label}>
                                    <span className={'schedule-info-label'}>{item.label}</span>
                                    <span className={'schedule-info-value'} title={item.value}>{item.value}</span>
                                </div>
                            );
                        })}
                    </div>
                    <List
                        noitemelem={<NoItems text={'This schedule has not run yet'}/>}
                        columns={columns}
                        getlist={this.props.getlist}
                        refreshRef={this.state.refreshRef}
                        filters={[{field: 'parentRequestId', value: schedule.id}]}/>
                </CardBody>
            </GdModal>
        );
    }
}

export default ScheduleRunsModal;
